import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';

import { PageActions, ImageBox, Section, TextArea, TextInput, SwitchInput, ImageInput, EditorInput } from '../components';
import DatePicker from 'react-datepicker';
import { userActions, generalActions } from '../actions';
import { generalService } from '../services';


class AboutPage extends React.Component {
  constructor(props) {
      super(props);

      this.pid = 403 ; //about page
      this.props.dispatch(generalActions.getContent(0,this.pid));  
      
      this.state = {
        id: null,
        payload:{
          banner:'',
          ilustrationHistoryp1:'',
          ilustrationHistoryp2:'',
          ilustrationOurClients:'',
          ilustrationVision:'',
          ilustrationMission:'',
          organigram:'',
          about:'',
          historyp1:'',
          historyp2:'',
          historyp3:'',
          clients:'',
          vision:'',
          mission:''

        },
        isLoaded :false
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

  }

  componentWillReceiveProps(props){

      const { content, upload } = props;
      const { data, id } = content;
      const { payload } = this.state;
      console.log(content);
      if(data){

        let dataPayload = {
          banner:data[0].banner,
          ilustrationHistoryp1:data[0].ilustrationHistoryp1,
          ilustrationHistoryp2:data[0].ilustrationHistoryp2,
          ilustrationOurClients:data[0].ilustrationOurClients,
          ilustrationVision:data[0].ilustrationVision,
          ilustrationMission:data[0].ilustrationMission,
          organigram:data[0].organigram,
          about:data[0].about,
          historyp1:data[0].historyp1,
          historyp2:data[0].historyp2,
          historyp3:data[0].historyp3,
          clients:data[0].clients,
          vision:data[0].vision,
          mission:data[0].mission
        }

        this.setState({ payload:dataPayload, id:data[0].id, isLoaded:true });

      }else{

        if(!upload.uploaded){
          setTimeout(()=>this.setState({ isLoaded: true}),1000);  
        }

      }

      if(upload.uploaded){
        this.setState({payload:{...payload, [this.state.lastEvent]:upload.data}});
      }
  }

  handleChange(e) { 
    const { name, value } = e.target;
    const { payload } = this.state;

    this.setState({payload:{...payload, [name]:value}});
  }

  handleFileChange(e) {
      const { name, value } = e.target;

      const file = e.target.files[0];
      const formData = new FormData();

      if(file){
        formData.set('file', file, file.name);
        
        if (formData) {
          this.props.dispatch(generalActions.postUpload(formData));
        }

        this.setState({lastEvent: name});
      }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { dispatch, content } = this.props;
    const { id } = this.state;
    const payload = this.state.payload;

    this.setState({ submitted: true });

    if(id){
      dispatch(generalActions.postContent(payload, id, this.pid));  
    }else{
      dispatch(generalActions.putContent(payload, this.pid));  
    }
  }

  handleDelete(e) {
    e.preventDefault();
    const { dispatch, content } = this.props;
    const { id } = this.state;

    if(id){
      dispatch(generalActions.deleteContent(id));  
    }
  }

  render() {
    const {payload} = this.state;
    return (
      <div className={this.state.isLoaded ? "content-wrapper" : "content-wrapper loader-light"}>
      {
        this.state.isLoaded ?
        <form role="form" name="contact" className="needs-validation" noValidate="true">
          <section className="content-header clearfix">
            <h1 className="content-header-title">
              About Us
            </h1>
            <div className="btn-placeholder">
              <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>
                <span className="visible-xs"><i className="fa fa-check"></i>&nbsp;</span>
                <span className="hidden-xs">Save</span>
              </button>
            </div>
          </section>
            <section className="content">
              <Section section_title="Banner" section_description=''>
                <div className="form-group">
                  <ImageInput
                    input_label="Banner"
                    input_name="banner"
                    input_helper="Recommended dimensions of 2160 × 2160 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.banner}
                  />
                  <TextArea
                    input_label="About Us"
                    input_placeholder="Enter About Us"
                    input_name="about"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.about}
                  />
                </div>
              </Section>
              <Section section_title="History" section_description=''>
                <div className="form-group">
                  <ImageInput
                    input_label="Ilustration History 1"
                    input_name="ilustrationHistoryp1"
                    input_helper="Recommended dimensions of 2160 × 2160 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.ilustrationHistoryp1}
                  />
                  <TextArea
                    input_label="History Pharagraph 1"
                    input_placeholder="Enter History Pharagraph 1"
                    input_name="historyp1"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.historyp1}
                  />
                  <ImageInput
                    input_label="Ilustration History 2"
                    input_name="ilustrationHistoryp2"
                    input_helper="Recommended dimensions of 2160 × 2160 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.ilustrationHistoryp2}
                  />
                  <TextArea
                    input_label="History Pharagraph 2"
                    input_placeholder="Enter History Pharagraph 2"
                    input_name="historyp2"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.historyp2}
                  />
                  <TextArea
                    input_label="History Pharagraph 3"
                    input_placeholder="Enter History Pharagraph 3"
                    input_name="historyp3"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.historyp3}
                  />
                </div>
              </Section>
              <Section section_title="Our Clients" section_description=''>
                <div className="form-group">
                  <ImageInput
                    input_label="Ilustration Clients"
                    input_name="ilustrationOurClients"
                    input_helper="Recommended dimensions of 2160 × 2160 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.ilustrationOurClients}
                  />
                  <TextArea
                    input_label="About Our Clients"
                    input_placeholder="Enter About Our Clients"
                    input_name="clients"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.clients}
                  />
                </div>
              </Section>
              <Section section_title="Vision & Misson" section_description=''>
                <div className="form-group">
                  <ImageInput
                    input_label="Ilustration Vision"
                    input_name="ilustrationVision"
                    input_helper="Recommended dimensions of 2160 × 2160 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.ilustrationVision}
                  />
                  <TextArea
                    input_label="Vision"
                    input_placeholder="Enter Vision"
                    input_name="vision"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.vision}
                  />
                  <ImageInput
                    input_label="Ilustration Mission"
                    input_name="ilustrationMission"
                    input_helper="Recommended dimensions of 2160 × 2160 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.ilustrationMission}
                  />
                  <TextArea
                    input_label="Mission"
                    input_placeholder="Enter Mission"
                    input_name="mission"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.mission}
                  />
                </div>
              </Section>
              <Section section_title="Organigram" section_description=''>
                <div className="form-group">
                  <ImageInput
                    input_label="Organigram"
                    input_name="organigram"
                    input_helper="Recommended dimensions of 2160 × 2160 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.organigram}
                  />
                </div>
              </Section>
            </section>
          </form>
          :
        <div className="loader"></div>
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { authentication, general } = state;
    const { content, upload } = general;
    return {
        content,
        upload
    };
}

const connectedAboutPage = connect(mapStateToProps)(AboutPage);
export { connectedAboutPage as AboutPage };


// WEBPACK FOOTER //
// ./src/pages/AboutPage.js